import React, { useContext, useEffect, useState } from 'react';
import { RocketImage, TickIcon } from 'src/assets/images';
import {
  SalesforceContext,
  AcquiringChannelFlags,
  CustomerTypes,
  ecommerceProductCategoryName,
} from 'src/context/salesforce-context';
import NavigationFooter from 'src/components/navigation-footer/navigation-footer';
import { SavedDocumentViewButtons } from 'src/containers/onboarding/create-account/confirm/document-download-buttons/document-download-buttons';
import MiniAppEvents from 'src/helpers/miniapp-events';
import TealiumEvents from 'src/helpers/tealium-events';
import { vfsHomeUrl } from 'src/common';
import './thank-you.scss';

export default function ThankYou() {
  const inMiniProgram = MiniAppEvents.isInMiniApp();
  const {
    merchant,
    solutionType,
    isResumedSession,
    isLoadingFromSessionStorage,
    uniqueTerminals,
    customerType,
    lead,
  } = useContext(SalesforceContext);
  const [multipleDevices, setMultipleDevices] = useState(false);
  const [screenState, setScreenState] = useState(0);

  const buyinstore = solutionType.includes(AcquiringChannelFlags.buyInstoreFicaOnline);

  const [redirect, setRedirect] = useState();

  const showDownloadButton = () =>
    !inMiniProgram &&
    (!solutionType.includes(AcquiringChannelFlags.buyInstoreFicaOnline) ||
      customerType === CustomerTypes.agent);

  const handleNext = () => {
    if (inMiniProgram) {
      MiniAppEvents.sendMessage({
        messageType: 'end_of_journey',
      });
    } else {
      setRedirect(vfsHomeUrl);
    }
  };

  const textTable = {
    bizWalletDevices: {
      orderDetails:
        'Once approved you will receive your device in 5 business days and email instructions for your Biz Wallet Pro',
      title: 'Thank you for your application ',
    },
    bizWallet: {
      orderDetails: 'Once approved you will receive email instructions for your Biz Wallet Pro',
      title: 'Thank you for your application ',
    },
    buyOnline: {
      orderDetails: `Once approved you will receive your device${
        multipleDevices ? 's' : ''
      } in 5 business days.`,
      title: 'Thank you for your application ',
    },
    buyInstore: {
      orderDetails: 'Once your FICA has been approved you will receive your login details.',
      title: 'Thank you for completing your registration ',
    },
  };

  const journeyName = () => {
    if (!merchant?.account?.sov_requested) {
      if (buyinstore) {
        return 'buyInstore';
      } else {
        return 'buyOnline';
      }
    } else {
      if (multipleDevices) {
        return 'bizWalletDevices';
      } else {
        return 'bizWallet';
      }
    }
  };

  useEffect(() => {
    //Change screen state after 3.5 seconds (after rocket animation)
    const timeout = setTimeout(() => {
      setScreenState(1);
    }, 3500);

    return () => clearTimeout(timeout);
  }, []);

  useEffect(() => {
    if (
      merchant?.account?.business_type &&
      !isLoadingFromSessionStorage &&
      uniqueTerminals &&
      Object.values(uniqueTerminals).length > 0
    ) {
      const deviceNameList = [];
      const quantityList = [];
      const priceList = [];
      const tenderList = [];
      let orderedRentalDevice = false;
      let orderedOnceOffFeeDevice = false;
      let falseTotal = 0;

      merchant.opportunity &&
        Object.values(merchant.opportunity.deliveries)
          .filter(
            (delivery) =>
              delivery.number_of_devices > 0 &&
              (!delivery.product_category || delivery.is_product_category),
          )
          .forEach((delivery) => {
            deviceNameList.push(delivery.device_name);
            quantityList.push(delivery.number_of_devices);
            const acquiringChannel = uniqueTerminals[delivery.device_id]?.acquiring_channel;
            priceList.push(delivery.price || 0);
            falseTotal += delivery.price * delivery.number_of_devices;
            orderedRentalDevice =
              orderedRentalDevice ||
              acquiringChannel === AcquiringChannelFlags.rentOnlineFicaOnline ||
              acquiringChannel === AcquiringChannelFlags.zeroRentOnlineFicaOnline;
            orderedOnceOffFeeDevice =
              orderedOnceOffFeeDevice ||
              acquiringChannel === AcquiringChannelFlags.buyOnlineFicaOnline;
          });

      merchant.opportunity &&
        Object.values(merchant.opportunity.deliveries)
          .filter(
            (product) =>
              product.number_of_devices > 0 &&
              product.product_category === ecommerceProductCategoryName &&
              !product.is_product_category,
          )
          .forEach((delivery) => {
            tenderList.push(delivery.device_name);
          });

      const assistantId = lead.dealerId || lead.agentId || '';
      setMultipleDevices(quantityList.some((item) => item > 1) || quantityList.length > 1);
      TealiumEvents.thankYouPageLoad(
        merchant.account.business_type,
        deviceNameList,
        quantityList,
        priceList,
        isResumedSession && customerType !== CustomerTypes.pos,
        orderedRentalDevice,
        orderedOnceOffFeeDevice,
        solutionType.includes(AcquiringChannelFlags.buyInstoreFicaOnline) ||
          customerType === CustomerTypes.pos
          ? 'in-store'
          : 'online',
        customerType,
        falseTotal,
        lead.monthlyCardTurnover,
        assistantId,
        merchant.opportunity.reference_no,
        lead.mobileNumber,
        lead.email,
        tenderList,
      );

      if (orderedOnceOffFeeDevice) {
        const assistantId = lead.dealerId || lead.agentId || '';
        TealiumEvents.thankYouPaymentGatewayJourneyEnd(customerType, assistantId);
      }
    }
  }, [merchant?.account?.business_type, isLoadingFromSessionStorage, uniqueTerminals]);

  if (redirect) {
    window.location.href = redirect;
    return null;
  }

  return (
    <>
      <div className="ThankYouParent" data-testid="UploadDocuments">
        {screenState == 0 ? (
          <div className="ThankYouPage move-up-animation">
            <div className="has-text-centered">
              <div className={screenState == 1 ? 'is-hidden' : ''}>
                <div className="rocket">
                  <img src={RocketImage} />
                </div>
                <div className="icon-container">
                  <div className={'tick-icon fade-in-icon' + (screenState == 1 ? 'is-hidden' : '')}>
                    <img src={TickIcon} />
                  </div>
                </div>
                <h1
                  className="page-title-thank-you heading-four has-padding-top-3 is-hidden-desktop"
                  automationid="Onboarding_Create_Account_Heading_One_Thank_You_Main_Message"
                >
                  Application Submitted
                </h1>
              </div>

              <div className={screenState == 0 ? 'is-hidden-mobile' : ''}>
                <h1
                  className="page-title-thank-you heading-four has-padding-top-2 has-mobile-padding-top-3 has-padding-x-2"
                  automationid="Onboarding_Create_Account_Heading_One_Thank_You_Main_Message"
                >
                  {textTable[journeyName()].title}
                  <div className="break-anywhere">{merchant.contact?.first_names}</div>
                </h1>

                <p
                  className="has-padding-x-3 has-padding-y-2 wrapping-container has-mobile-padding-x-4 has-text-blue-grey-3 has-mobile-padding-bottom-3 has-mobile-padding-top-5"
                  automationid="Onboarding_Create_Account_Paragraph_Thank_You_Secondary_Message"
                >
                  Our team is currently reviewing your application and you should receive an email
                  with feedback within 2 business days.
                </p>

                <div className="once-approved-box wrapping-container has-padding-y-5 has-padding-x-2 has-text-blue-grey-2 has-margin-bottom-1">
                  <p>{textTable[journeyName()].orderDetails}</p>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="ThankYouPage">
            <div className="has-text-centered">
              <div className={`tick-icon`}>
                <img className="icon-top-margin" src={TickIcon} />
              </div>
              <div>
                <h1
                  className="page-title-thank-you heading-four has-padding-top-3 is-hidden-desktop"
                  automationid="Onboarding_Create_Account_Heading_One_Thank_You_Main_Message"
                >
                  Application Submitted
                </h1>
                <h1
                  className="page-title-thank-you heading-four has-padding-top-2 has-mobile-padding-top-3 has-padding-x-2"
                  automationid="Onboarding_Create_Account_Heading_One_Thank_You_Main_Message"
                >
                  {textTable[journeyName()].title}
                  <div className="break-anywhere">{merchant.contact?.first_names}</div>
                </h1>

                <p
                  className="has-padding-x-3 has-padding-y-2 wrapping-container has-mobile-padding-x-4 has-text-blue-grey-3 has-mobile-padding-bottom-3 has-mobile-padding-top-5"
                  automationid="Onboarding_Create_Account_Paragraph_Thank_You_Secondary_Message"
                >
                  Our team is currently reviewing your application and you should receive an email
                  with feedback within 2 business days.
                </p>

                <div className="once-approved-box wrapping-container has-padding-y-5 has-padding-x-2 has-text-blue-grey-2 has-margin-bottom-1">
                  <p>{textTable[journeyName()].orderDetails}</p>
                </div>
                {showDownloadButton() && <SavedDocumentViewButtons customerType={customerType} />}
              </div>
            </div>
          </div>
        )}

        <NavigationFooter
          nextButtonLabel="Done"
          onNext={handleNext}
          hideSaveForLater={true}
          hideBack={true}
          hideCancel={true}
          nextEnabled={true}
          automationIdPrefix="Onboarding"
        />
      </div>
    </>
  );
}
